import _objectSpread from "/codebuild/output/src1506462530/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { addMembershipBundleToUserApiCall, archiveBundleApiCall, createMembershipBundleApiCall, getAllMembershipsAssignedToABundleApiCall, getBundleByIdApiCall, getBundleItemsApiCall, getCustomerBundleItemsApiCall, getProviderBundlesApiCall, getProviderMembershipBundlesApiCall, getUserBundleByIdApiCall, getUserBundlesApiCall, toggleBundleStatusApiCall, updateBundleApiCall } from '@guryou/api-client-gql';
import { execute } from '../actions/actionWrapper';
import { Action, basicReducer } from '../core';
export const GET_PROVIDER_BUNDLES = {
  entity: 'GET_PROVIDER_BUNDLES',
  action: Action.GET_MANY
};
export const GET_USER_BUNDLES = {
  entity: 'GET_USER_BUNDLES',
  action: Action.GET_MANY
};
export const GET_BUNDLE_BY_ID = {
  entity: 'GET_BUNDLE_BY_ID',
  action: Action.GET_ONE
};
export const GET_USER_BUNDLE_BY_ID = {
  entity: 'GET_USER_BUNDLE_BY_ID',
  action: Action.GET_ONE
};
export const GET_BUNDLE_ITEMS = {
  entity: 'GET_BUNDLE_ITEMS',
  action: Action.GET_MANY
};
export const GET_CUSTOMER_BUNDLE_ITEMS = {
  entity: 'GET_CUSTOMER_BUNDLE_ITEMS',
  action: Action.GET_MANY
};
export const GET_BUNDLE_MEMBERSHIP = {
  entity: 'GET_BUNDLE_MEMBERSHIP',
  action: Action.GET_MANY
};
export const CREATE_BUNDLE_MEMBERSHIP = {
  entity: 'CREATE_BUNDLE_MEMBERSHIP',
  action: Action.CREATE
};
export const UPDATE_BUNDLE = {
  entity: 'UPDATE_BUNDLE',
  action: Action.UPDATE
};
export const TOGGLE_BUNDLE_STATUS = {
  entity: 'TOGGLE_BUNDLE_STATUS',
  action: Action.UPDATE
};
export const ARCHIVE_BUNDLE = {
  entity: 'ARCHIVE_BUNDLE',
  action: Action.ARCHIVE
};
export const ADD_MEMBERSHIP_BUNDLE_TO_USER = {
  entity: 'ADD_MEMBERSHIP_BUNDLE_TO_USER',
  action: Action.CREATE
};
export const BUNDLE_MEMBERSHIP_IDS = {
  entity: 'BUNDLE_MEMBERSHIP_IDS',
  action: Action.GET_ONE
};
export const getProviderBundles = () => async dispatch => execute(dispatch, () => getProviderBundlesApiCall({
  group: ['id', 'name', 'color']
}), GET_PROVIDER_BUNDLES, false);
export const getUserBundles = (userId, customerId) => async dispatch => execute(dispatch, () => getUserBundlesApiCall({
  userId,
  customerId
}, {
  group: ['id', 'name', 'color']
}), GET_USER_BUNDLES, false);
export const getBundleById = id => async dispatch => execute(dispatch, () => getBundleByIdApiCall({
  id
}), GET_BUNDLE_BY_ID, false);
export const getUserBundleById = id => async dispatch => execute(dispatch, () => getUserBundleByIdApiCall({
  id
}), GET_USER_BUNDLE_BY_ID, false);
export const getBundleItems = id => async dispatch => execute(dispatch, () => getBundleItemsApiCall({
  id
}), GET_BUNDLE_ITEMS, false, {
  id
});
export const getCustomerBundleItems = userBundleId => async dispatch => execute(dispatch, () => getCustomerBundleItemsApiCall({
  userBundleId
}), GET_CUSTOMER_BUNDLE_ITEMS, false, {
  id: userBundleId
});
export const getMembershipBundles = () => async dispatch => execute(dispatch, () => getProviderMembershipBundlesApiCall(), GET_BUNDLE_MEMBERSHIP, false);
export const createMembershipBundle = input => async dispatch => execute(dispatch, () => createMembershipBundleApiCall({
  request: input
}), CREATE_BUNDLE_MEMBERSHIP, true);
export const updateBundle = input => async dispatch => execute(dispatch, () => updateBundleApiCall({
  request: input
}), UPDATE_BUNDLE, true);
export const toggleBundleStatus = (id, value) => async dispatch => execute(dispatch, () => toggleBundleStatusApiCall({
  id,
  value
}), TOGGLE_BUNDLE_STATUS, true);
export const archiveBundle = id => async dispatch => execute(dispatch, () => archiveBundleApiCall({
  id
}), ARCHIVE_BUNDLE, true);
export const addMemebershipBundleToUser = input => async dispatch => {
  const iinput = _objectSpread(_objectSpread({}, input), {}, {
    userId: +input.userId || null,
    customerId: input.userId ? null : +input.customerId || null,
    price: +input.price,
    paid: input !== null && input !== void 0 && input.paid ? +input.paid : null
  });
  execute(dispatch, () => addMembershipBundleToUserApiCall({
    request: iinput
  }), ADD_MEMBERSHIP_BUNDLE_TO_USER, true);
};
export const getAllMembershipsAssignedToABundle = () => async dispatch => execute(dispatch, () => getAllMembershipsAssignedToABundleApiCall(), BUNDLE_MEMBERSHIP_IDS, false);
export const bundleReducers = {
  getBundles: basicReducer(GET_PROVIDER_BUNDLES),
  getUserBundles: basicReducer(GET_USER_BUNDLES),
  getBundle: basicReducer(GET_BUNDLE_BY_ID),
  getUserBundle: basicReducer(GET_USER_BUNDLE_BY_ID),
  getItems: basicReducer(GET_BUNDLE_ITEMS),
  getCustomerItems: basicReducer(GET_CUSTOMER_BUNDLE_ITEMS),
  getBundleMemberships: basicReducer(GET_BUNDLE_MEMBERSHIP),
  createBundleMembership: basicReducer(CREATE_BUNDLE_MEMBERSHIP),
  update: basicReducer(UPDATE_BUNDLE),
  toggleStatus: basicReducer(TOGGLE_BUNDLE_STATUS),
  archive: basicReducer(ARCHIVE_BUNDLE),
  addMembershipBundle: basicReducer(ADD_MEMBERSHIP_BUNDLE_TO_USER),
  bundleMembershipIds: basicReducer(BUNDLE_MEMBERSHIP_IDS)
};